import { ROLES, isFlightCrewRole, isRosterCrewRole } from '../constants/roles';

/**
 * Company CREW and LOAN_PILOT appear on duty roster selectors only after final
 * onboarding approval. Legacy users with no onboardingStatus remain eligible
 * when still active/pilot-active. EXTERNAL_PILOT is never roster-eligible.
 */
export function isCrewRosterEligible(user) {
  if (!user || !isRosterCrewRole(user.role)) return false;
  if (user.isActive === false) return false;
  if (user.isPilotActive === false) return false;
  const status = user.onboardingStatus;
  if (status == null) return true;
  return status === 'FULLY_ONBOARDED';
}

export function filterRosterEligibleCrew(users = []) {
  return users.filter(isCrewRosterEligible);
}

/** Assignable to a trip/sector (CREW/LOAN fully onboarded, or EXTERNAL_PILOT when active). */
export function isCrewAssignable(user) {
  if (!user || user.isActive === false) return false;
  if (user.role === ROLES.EXTERNAL_PILOT) {
    return user.isPilotActive !== false;
  }
  return isCrewRosterEligible(user);
}

export function filterAssignableCrew(users = []) {
  return users.filter(isCrewAssignable);
}

export { isFlightCrewRole, isRosterCrewRole };
